// extracted by mini-css-extract-plugin
export default {"container":"modal_container__mx-db","header":"modal_header__ZrtET","closeIcon":"modal_closeIcon__HrLJF","title":"modal_title__+K4Dm"};